var _style, _defs, _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tail_svg__Layer_6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 168.7 261.95",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".tail_svg__st1{fill:#fc784f}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "tail_svg__SVGID_1_",
    transform: "rotate(-89.82 69.799 130.591)",
    d: "M-59.61 25h258.82v211.18H-59.61z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "tail_svg__SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#tail_svg__SVGID_1_",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tail_svg__SVGID_2_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "tail_svg__st1",
    d: "M133.81.79c-7.64.04-15.27.66-22.81 1.86C41.55 13.26-4.44 64.03 2.76 146.13s86.39 109.76 108.8 113.41c-3.24-.52 24.82 6.48 24.89-13.83 0-12.91-8.45-13.94-14.78-14.86-2.39-.35-4.75-.84-7.08-1.48-1.19-.32-2.58-.7-4.13-1.17-27.28-8.16-105-40.61-71.34-139.29 0 0 20-54.93 90.4-57.57 48-1.8 50.3-30.4 4.29-30.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "tail_svg__st1",
    d: "M123.45 230.04c-1.98 9.94-2.99 20.05-3 30.18l7.92-29s-1.8-.34-4.89-1.16"
  }))));
}
export default __webpack_public_path__ + "819573ab0c963795c63d8e1d35e6f69d.svg";
export { SvgTail as ReactComponent };